import { windowWidth, windowHeight, scrollPos, headerHeight } from '../dimensions'
import Observable from './Observable';


const toggle = new Observable(false)
export const refreshBcrs = () => toggle.set(!toggle.get())
jQuery($ => {
  $('img').load(refreshBcrs)
})

export const getBcrAbsolute = element => {
  let el = $(element).get(0)
  return Observable.combine([windowHeight, windowWidth, toggle], () => {
    const currentScrollPos = scrollPos.get()
    const bcr = el.getBoundingClientRect()
    return {
      top: bcr.top + currentScrollPos,
      height: bcr.height,
      bottom: bcr.bottom + currentScrollPos,
      left: bcr.left,
      right: bcr.right,
      width: bcr.width
    }
  })
}

export default element => {
  let el = $(element).get(0)
  return Observable.combine([getBcrAbsolute(el), scrollPos], ([bcr, scrollPos]) => ({
    ...bcr,
    top: bcr.top - scrollPos,
    bottom: bcr.bottom - scrollPos
  }))
}